import request from './base'
import store from '../store'
const requestApi = {
  getSlideCode(){
    return request({
      url: '/api/member/getCaptcha',
      method: 'get'
    })
  },
  checkSlide(data){
    //console.log(data)
    let pointJson = JSON.parse(data.pointJson || "{}");
    let obj = {phone:data.phone,sliderX:pointJson.x}
    return request({
      url: '/api/member/sendCode',
      method: 'GET',
      params: obj
    })
  },
  //发送验证码
  sendCode(phone) {
    return request({
      url: `/api/member/sendCode?phone=${phone}`,
      method: 'get',
    })
  },
 
  //登录
 login(data) {
   //memberSource 来源(0-h5,1-pc,2-终端)
    return request({
      url: `/api/member/login`,
      method: 'get',
      params:data
    })
  },
//法官信息
judgedetail(data){
  return request({
    url: `/api/judge/detail`,
    method: 'get',
    params:data
  })
 },
 //用户信息
userInfo(data){
  return request({
    url: `/api/member/detail`,
    method: 'get',
    params:data
  })
 },
//身份证解析
idCardAnalysis(data){
  return request({
    url: `/api/member/idCardAnalysis`,
    method: 'get',
    params:data
  })
},
//资料修改
editInfo(data){
  return request({
    url: `/api/member/editInfo`,
    method: 'post',
    params:data
  })
},
//身份验证(上传头像
personVerify(data){
  return request({
    url: `/api/member/personVerify`,
    method: 'get',
    params:data
  })
},
//当事人案件列表
getListByMember(data){
  return request({
    url: `/api/caseinfo/getListByMember`,
    method: 'get',
    params:data
  })
},

//案件详情
caseinfoDetail(data){
  return request({
    url: `/api/caseinfo/Detail`,
    method: 'get',
    params:data
  })
},

//获取聊天记录
messageBoardGetList(data){
  return request({
    url: `/api/messageBoard/GetList`,
    method: 'get',
    params:data
  })
},
  //法官的案件列表
  getListByJudge(data){
    return request({
      url: `/api/caseinfo/getListByJudge`,
      method: 'get',
      params:data
    })
},
// 公开法官的列表
openJudgeGetList(data){
  return request({
    url: `/api/openJudge/getList`,
    method: 'get',
    params:data
  })
},
//新增聊天用的caseid
addJudgeMessage(data){
  return request({
    url: `/api/caseinfo/addJudgeMessage`,
    method: 'get',
    params:data
  })

},
  //新增留言
  messageBoardAdd(data){
    return request({
      url: `/api/messageBoard/Add`,
      method: 'post',
      params:data
    })
},
//从司法公开库同步案件
caseinfoSynchronize(data){
  return request({
    url: `/api/caseinfo/synchronize`,
    method: 'get',
    params:data
  })

},

//获取法官列表
openJudgegetList(data){
  return request({
    url: `/api/openJudge/getList`,
    method: 'get',
    params:data
  })

},
//更新法官
caseinfoupdateJudge(data){
  return request({
    url: `/api/caseinfo/updateJudge`,
    method: 'get',
    params:data
  })

},
//更新法官admin用
updateGtJudge(data){
  return request({
    url: `/api/caseinfo/updateGtJudge`,
    method: 'get',
    params:data
  })

},
//主页初始化
getHome(data){
  return request({
    url: `/api/module/getHome`,
    method: 'get',
    params:data
  })

},
//开具生效证明数据初始化
kjsczminit(data){
  return request({
    url: `/api/caseApplication/load`,
    method: 'get',
    params:data
  })
},
//新增生效证明表单
caseApplicationAdd(data){
  return request({
    url: `/api/caseApplication/add`,
    method: 'post',
    params:data
  })
},
//生效证明/调取材料列表(当事人)
sxzmOrDqclList(data){
  return request({
    url: `/api/caseApplication/getListByMember`,
    method: 'get',
    params:data
  })
},
//生效证明/调取材料列表(法官)
sxzmOrDqclListByJudge(data){
  return request({
    url: `/api/caseApplication/getListByJudge`,
    method: 'get',
    params:data
  })
},
//生效证明/调取材料详情
sxzmOrDqclDetail(data){
  return request({
    url: `/api/caseApplication/detail`,
    method: 'get',
    params:data
  })
},
//生效证明/调取材料法官审核
processAudit(data){
  return request({
    url: `/api/process/audit`,
    method: 'post',
    params:data
  })
},

//调取材料申领新增
caseApplicationbatchAdd(data){
  return request({
    url: `/api/caseApplication/batchAdd`,
    method: 'post',
    params:data
  })
},
//调解员列表
mediatorgetList(data){
  return request({
    url: `/api/mediator/getList`,
    method: 'get',
    params:data
  })

},
//调解员详情
mediatordetail(data){
  return request({
    url: `/api/mediator/detail`,
    method: 'get',
    params:data
  })

},
//调解案件列表
mediatorgetCaseList(data){
  return request({
    url: `/api/mediator/getCaseList`,
    method: 'get',
    params:data
  })

},

//添加模块日志
addModuleLog(data){
  return request({
    url: `/api/module/addModuleLog`,
    method: 'get',
    params:data
  })
},

//微信绑定
wechatBind(data){
  return request({
    url: `/api/member/wechatBind`,
    method: 'get',
    params:data
  })
},
//微信授权
wechatAuthorized(data){
  return request({
    url: `/api/member/wechatAuthorized`,
    method: 'get',
    params:data
  })
},
//法官微信授权
judgeAuthorize(data){
  console.log('judgeAuthorizejudgeAuthorizejudgeAuthorize')
  return request({
    url: `/api/judge/authorize`,
    method: 'post',
    params:data
  })
},

//网诉用户绑定
memberBind(data){
  return request({
    url: `/api/memberBind/bind`,
    method: 'get',
    params:data
  })
},



//登录页面初始化
loginLoad(data){
  return request({
    url: `/api/member/loginLoad`,
    method: 'get',
    params:data
  })
},
//获取部门
getTree(data){
  return request({
    // url: `/api/dept/getTree`,
    url:'/api/dept/getTreeByWechat',
    method: 'get',
    params:data
  })
},
//获取流程方案列表
processProgramGetList(data){
  return request({
    url: `/api/processProgram/getList`,
    method: 'get',
    params:data
  })
},

//添加流程方案
processProgramAdd(data){
  return request({
    url: `/api/processProgram/add`,
    method: 'post',
    params:data
  })
},
//批量添加流程节点
ProcessSettingAddList(data){
  return request({
    url: `/api/ProcessSetting/addList`,
    method: 'post',
    params:data
  })
},
//流程方案详情
processProgramDetail(data){
  return request({
    url: `/api/processProgram/detail`,
    method: 'get',
    params:data
  })
},
//删除流程方案
processProgramDeleteById(data){
  return request({
    url: `/api/processProgram/deleteById`,
    method: 'get',
    params:data
  })
},

//提交材料审核流程
applicationMaterialAssign(data){
  return request({
    url: `/api/applicationMaterial/assign`,
    method: 'post',
    params:data
  })
},

//获取法官列表
judgeGetList(data){
  return request({
    url: `/api/judge/getList`,
    method: 'get',
    params:data
  })
},

//删除案件材料
deleteMaterial(data){
  return request({
    url: `/api/upload/deleteMaterial`,
    method: 'get',
    params:data
  })
},

//验证码提示
tips(data){
  return request({
    url: `/api/platformCode/detail`,
    method: 'get',
    params:data
  })
},
//上传文件
uploadFile(file) {
  let formData = new FormData();
  formData.append("file",file);
  // formData.append("appId",glConfig.APPID);
  // formData.append("userId ",store.state.user.userInfo.userId);
  return request({
    url: `/quickoffice/userFile/add`,
    method: 'post',
    data:formData,
    headers:{
      'Content-Type':'multipart/form-data'
    }
  })
}, 
//获取企业微信信息
settingLoad(){
  return request({
    url: `/api/setting/load`,
    method: 'get',
  })
},
//获取省市区数据
getDownList(data){
  return request({
    url: `/api/address/getDownList`,
    method: 'get',
    params:data
  })
},
//判断案件是否需要选择区县
updateAddress(data){
  return request({
    url: `/api/caseinfo/updateAddress`,
    method: 'get',
    params:data

  })
},
//判断是否登录
documentFreeLogin(data){
  return request({
    url: `/api/member/documentFreeLogin`,
    method: 'get',
    params:data
  })
},
// 12368法官列表
openJudgeGetList(data){
  return request({
    url: `/api/openJudge/getList`,
    method: 'get',
    params:data
  })
},

// 数据初始化
caseinfoLoad(data){
  return request({
    url: `/api/caseinfo/load`,
    method: 'get',
    params:data
  })
},


// 12368新增留言
caseinfoAdd(data){
  return request({
    url: `/api/caseinfo/add`,
    method: 'post',
    params:data
  })
},
//点击率
visitadd(data){
  return request({
    url: `/api/visit/add`,
    method: 'post',
    params:data
  })
},

//点击率tongji
visitstat(data){
  return request({
    url: `/api/visit/stat`,
    method: 'get',
    params:data
  })
},
//中转页法官验证
judgeVerify(data){
  return request({
    url: `/api/judge/Verify`,
    method: 'post',
    params:data
  })
},
// //分配或者变更法官和书记员
// updateJudge(data){
//   return request({
//     url: `/api/caseinfo/updateJudge`,
//     method: 'get',
//     params:data
//   })
// },

















  
}

export default requestApi;






// WEBPACK FOOTER //
// ./src/api/request.js